module.exports = __webpack_public_path__ + "media/images/pricing-banner-2-b6e54a9337557e865352b092399e7f3d.png";